/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

import Button from './buttons/primary'

type Props = {
    title: string
    price: string
    renewal: 'monthly' | 'quarterly' | 'yearly'
    link: string
}

const Plan: React.FC<Props> = ({ title, price, renewal, link, children }) => {
    return (
        <div className="">
            <div className="header bg-primary-lighter p-6 rounded-t-md text-center">
                <h1 className="text-gray-100 font-semibold text-2xl mb-2">{title}</h1>
                <h2 className="text-gray-100 font-medium">${price} <span className="text-gray-300 font-normal text-sm">/{renewal}</span></h2>
            </div>
            <div className="body bg-primary-light px-6 pt-7">
                <ul>
                    {children}
                </ul>
            </div>
            <div className='footer bg-primary-light pt-5 pb-7 px-5 flex items-center justify-center rounded-b-md'>
                <Button rounded='sm' arrow={true} length='sm' link={'https://billing.stellanode.com/index.php?rp=/store/' + link}>Select Plan</Button>
            </div>
        </div>
    )
}

export default Plan